
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-bold mb-4">ZÓNA s.r.o.</h3>
            <p className="text-gray-400 leading-relaxed">
              Professional VPN solutions for secure and private internet access. Protecting your digital life with advanced encryption technology.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#features" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Features
                </a>
              </li>
              <li>
                <a href="#about" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <a href="mailto:contact@zonasro.com" className="hover:text-white transition-colors cursor-pointer">
                  contact@zonasro.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <a href="tel:+13519998566" className="hover:text-white transition-colors cursor-pointer">
                  +1 351 999 8566
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-1"></i>
                <span>324/3 Savolska cesta, 986 01 Fiľakovo, Slovakia</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {currentYear} ZÓNA s.r.o. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
